"use client";

import { ArrowRight, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Consultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const proofPoints = [{
    value: "150",
    suffix: "+",
    label: "Industrial facilities secured",
    caption: "Across high-hazard sectors globally"
  }, {
    value: "24",
    suffix: " standards",
    label: "Technical compliance mapped",
    caption: "NFPA, FM Global, and international codes"
  }, {
    value: "99.8",
    suffix: "%",
    label: "Risk mitigation success rate",
    caption: "Validated by insurance underwriters in 2024"
  }];
  return <section data-section-id="11335" id="initiate-consultation" className="dark bg-background text-foreground py-32 md:py-44 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div ref={ref} className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {}
        <div className={`lg:col-span-7 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div className="flex items-center gap-3 mb-8">
            <span className="block w-3 h-px bg-primary" aria-hidden="true" />
            <span className="text-xs font-semibold uppercase text-foreground/70" style={{
            letterSpacing: "0.14em",
            fontFamily: "var(--font-sans)"
          }}>
              Engineering Partnership
            </span>
          </div>

          {}
          <h2 className="font-default font-normal text-foreground leading-[1.08]" style={{
          fontFamily: "var(--font-serif)",
          fontSize: "clamp(2.1rem, 3.6vw, 3.25rem)",
          letterSpacing: "-0.015em"
        }}>
            Resilience engineered for{" "}
            <span className={`italic text-primary inline-block transition-opacity duration-500 ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
            transitionDelay: isVisible ? "200ms" : "0ms"
          }}>
              critical
            </span>{" "}
            infrastructure.
          </h2>

          {}
          <p className="mt-6 max-w-[480px] text-foreground/75 font-default" style={{
          fontSize: "clamp(1.0625rem, 1.05vw, 1.1875rem)",
          lineHeight: 1.55,
          letterSpacing: "-0.002em"
        }}>
            Bedrock Safety Engineering provides rigorous fire protection and risk management for aerospace, pharmaceutical, and industrial manufacturing. Secure your assets with technical precision.
          </p>

          {}
          <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium px-6 py-6 h-auto rounded-lg w-full sm:w-auto">
              <Link to="/ContactPage">
                Initiate Consultation
                <ArrowRight className="size-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" className="bg-transparent border border-foreground/80 text-foreground hover:bg-foreground hover:text-background font-medium px-6 py-6 h-auto rounded-lg w-full sm:w-auto">
              <Link to="#">
                <Download className="size-4" />
                Review Engineering Capabilities
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className={`lg:col-span-5 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: "160ms"
      }}>
          <div className="border border-foreground/20 p-8 md:p-10 rounded-lg">
            {proofPoints.map((p, i) => <div key={i} data-index={i} className={`flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-6 py-6 first:pt-0 last:pb-0 ${i !== proofPoints.length - 1 ? "border-b border-foreground/15" : ""}`}>
                <div className="text-primary shrink-0" style={{
              fontFamily: "var(--font-mono)",
              fontSize: "clamp(2.25rem, 3.4vw, 3rem)",
              fontWeight: 500,
              letterSpacing: "-0.03em",
              lineHeight: 1
            }}>
                  {p.value}
                  <span>{p.suffix}</span>
                </div>
                <div className="flex-1">
                  <h4 className="font-default text-foreground" style={{
                fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)",
                fontWeight: 600,
                letterSpacing: "-0.004em",
                lineHeight: 1.35
              }}>
                    {p.label}
                  </h4>
                  <p className="mt-1 text-foreground/60 font-default" style={{
                fontSize: "0.8125rem",
                lineHeight: 1.45,
                letterSpacing: "0.01em"
              }}>
                    {p.caption}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}